import React from 'react';
import styled from 'styled-components/macro';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slide from './Slide';
import imgImprove1 from '../../assets/img/improve.1.png';
import imgImprove2 from '../../assets/img/improve.2.png';
import imgImprove3 from '../../assets/img/improve.3.png';

const StyledSlider = styled(Slider)`
  & > .slick-dots {
    position: relative;
    bottom: 0;
  }
`;

const I = styled.i`
  opacity: 0.7;
`;

const ArrowWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  height: 100%;
  top: 50%;
  transform: translate(0, -50%);
  display: ${props => (props.disabled ? 'none' : 'flex')};
  z-index: 100;
  background-color: ${props => props.theme.howKidsImprove.backgroundColor};
  align-items: center;
`;

const PrevArrow = ({ className, onClick }) => {
  const disabled = /disabled/.test(className);
  return (
    <ArrowWrapper onClick={onClick} disabled={disabled}>
      <I className="fas fa-chevron-left fa-2x"></I>
    </ArrowWrapper>
  );
};

const NextArrowWrapper = styled(ArrowWrapper)`
  right: 0;
`;

const NextArrow = ({ className, onClick }) => {
  const disabled = /disabled/.test(className);
  return (
    <NextArrowWrapper onClick={onClick} disabled={disabled}>
      <I className="fas fa-chevron-right fa-2x"></I>
    </NextArrowWrapper>
  );
};

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    // Custom Arrows
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    // Custom Dots
    appendDots: dots => {
      return (
        <div style={{ marginTop: 24 }}>
          {dots.map((dot, i) => {
            const active = /active/.test(dot.props.className);
            return (
              <li key={i} onClick={dot.props.children.props.onClick}>
                <i
                  className={
                    active ? 'fas fa-circle fa-sm' : 'far fa-circle fa-sm'
                  }
                ></i>
              </li>
            );
          })}
        </div>
      );
    },
  };

  return (
    <StyledSlider {...settings}>
      <Slide number="1" title="Meet the Wuzzits" img={imgImprove1}>
        Kids and adults of all ages love rescuing the Wuzzits while developing
        their problem-solving skills.
      </Slide>
      <Slide number="2" title="Play for 10 minutes 3x/week" img={imgImprove2}>
        As parents, we design our puzzles to maximize impact and minimize screen
        time.
      </Slide>
      <Slide number="3" title="Get your first BQ Score" img={imgImprove3}>
        The BQ Score provides your children and you with new insights into your
        children’s problem-solving skills.
      </Slide>
    </StyledSlider>
  );
};

export default Carousel;
